module.exports = __webpack_public_path__ + "img/gbWhatsAppUpdated.0999204f.webp";